import { render, staticRenderFns } from "./WebServiceConfigurationDetails.vue?vue&type=template&id=48c0c66e&"
import script from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./WebServiceConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports